/* Styles */
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'

/* Router & Store */
import router from './router'
import store from './store'

/* Service Worker */
import './registerServiceWorker'

/* Vue. Main component */
import App from './App.vue'

/* Vue. Component in recursion */
import AsideMenuList from '@/components/AsideMenuList'


import Utils from '@/classes/Utils'
const utils = new Utils(process.env.VUE_APP_IS_DEBUG)
Vue.prototype.$utils = utils

import Api from '@/classes/Api'
const api = new Api()
Vue.prototype.$api = api

import Auth from '@/classes/Auth'
const auth = new Auth()
Vue.prototype.$auth = auth

import Consts from '@/classes/Consts'
const consts = new Consts()
Vue.prototype.$consts = consts


/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit('asideMobileStateToggle', false)
  store.commit('overlayToggle', false)
  store.commit('asideActiveForcedKeyToggle', null)
})

Vue.config.productionTip = false

/* These components are used in recursion algorithm */
Vue.component('AsideMenuList', AsideMenuList)

Vue.use(Buefy)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.documentElement.classList.remove('has-spinner-active')
  }
}).$mount('#app')
